/* eslint-disable no-console */
import { getLogger } from './commons/logger';
import { promiseTimeout, promiseMap } from './utils';

const logger = getLogger('process-handler');
const exitHooks: Array<() => void | PromiseLike<void>> = [];

export function registerProcessForCleanup(onExit: (e?: any) => void | PromiseLike<any>, _process = process) {
    async function cleanup(err: any) {
        // give cleanup and socket reports a chance to run
        await promiseTimeout(promiseMap(exitHooks, async hook => hook()), 10000).catch(() => null);
        onExit(err);
    }
    _process.on('uncaughtException', async (err) => {
        if (err.message.includes('Command browsingContext')) {
            // Ignore deep BiDi errors.
            return;
        }
        logger.error('Caught exception', { err });
        console.log('Uncaught exception');
        if (err.message) {
            console.log('Message =', err.message);
        }
        if ((err as any).reason) {
            console.log('Reason =', (err as any).reason);
        }
        await cleanup(err);
    });

    _process.on('unhandledRejection', (reason) => {
        // rollout manages promises incorrectly and generates unhandled rejections from within their code
        logger.fatal('Caught unhandled promise rejection', reason as any);
        //TODO(benji) - this is a pretty shitty way to detect this error since rollout can change their API endpoint
        if ((reason as any)?.message?.includes('ENOTFOUND x-api.rollout.io')) {
            // this is not a fatal error - we recover from this in feature-flags service
            return;
        }

        throw reason;
    });

    _process.on('rejectionHandled', () => {
        logger.error('Caught rejection handled');
    });

    _process.once('SIGTERM', () => {
        const msg = 'Runner aborted - SIGTERM event';
        const err = new Error(msg);
        logger.error(msg);
        cleanup(err);
        throw err;
    });

    _process.once('SIGINT', () => {
        const msg = 'Runner aborted - SIGINT event';
        const err = new Error(msg);
        logger.error(msg);
        cleanup(err);
        throw err;
    });

    // One time self-call is expected :(
    _process.once('exit', (e) => {
        onExit(e);
    });
}

export function registerExitHook(hook: () => void | PromiseLike<any>) {
    exitHooks.push(hook);
}

export function reset() {
    exitHooks.splice(0, exitHooks.length);
}
